// ── Pure formatting helpers ───────────────────────────────────────────────────

export function formatLastRefresh(ts) {
  if (!ts || !Number.isFinite(ts)) return '—';
  try {
    return new Date(ts).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'medium' });
  } catch (_) {
    return '—';
  }
}

export function formatLogTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch (_) {
    return iso;
  }
}

export function fmtStatusLabel(val) {
  if (val === null || val === undefined || val === '') return null;
  return String(val).replace(/_/g, ' ');
}

export function fmtBoolLabel(val) {
  if (val === null || val === undefined) return null;
  return val ? 'Sent' : 'Not sent';
}

export function fmtShouldContactLabel(val) {
  if (val === null || val === undefined) return null;
  return val ? 'Yes' : 'No';
}

export function fmtNoteLabel(val) {
  if (val === null || val === undefined || val === '') return null;
  return String(val);
}

export function shouldShowTooltip(text, max_chars) {
  return String(text ?? '').length > max_chars;
}

export function normalizeToE164(phone) {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits[0] === '1') return `+${digits}`;
  if (digits.length > 7) return `+${digits}`;
  return null;
}

export function fmtRecDuration(seconds) {
  if (!seconds && seconds !== 0) return '—';
  const s = Number(seconds);
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

export function fmtRecDate(raw) {
  if (!raw) return '—';
  try {
    return new Date(raw).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  } catch (_) {
    return raw;
  }
}

export function formatStatusLabel(statusValue) {
  return String(statusValue ?? '')
    .trim()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function parseStatusValueForApi(labelOrValue) {
  const raw = String(labelOrValue ?? '').trim().toLowerCase();
  switch (raw) {
    case 'not onboarded yet':
    case 'not_onboarded_yet':
      return 'not_onboarded_yet';
    case 'onboarding in progress':
    case 'onboarding_in_progress':
      return 'onboarding_in_progress';
    case 'onboarded':
      return 'onboarded';
    case 'onboarding failed':
    case 'onboarding_failed':
      return 'onboarding_failed';
    case 'contacted restaurant':
    case 'contacted_restaurant':
      return 'contacted_restaurant';
    case 'meeting scheduled':
    case 'meeting_scheduled':
      return 'meeting_scheduled';
    default:
      return 'not_onboarded_yet';
  }
}

export function formatMarketingUpdateError(rawError) {
  const fallback = 'Could not update lead.';
  const message = String(rawError ?? '').trim();
  if (!message) return fallback;

  const transitionMatch = message.match(
    /Invalid current_status transition from ([a-z_]+) to ([a-z_]+)\. Allowed next status: (.+)$/i
  );

  if (!transitionMatch) return message;

  const fromStatus = formatStatusLabel(transitionMatch[1]);
  const toStatus = formatStatusLabel(transitionMatch[2]);
  const allowedText = String(transitionMatch[3] ?? '').trim();
  if (!allowedText || allowedText.toLowerCase() === 'none') {
    return `Status cannot be changed from ${fromStatus} to ${toStatus}.`;
  }

  const allowedStatusList = allowedText
    .split(',')
    .map((item) => formatStatusLabel(item))
    .filter(Boolean)
    .join(', ');

  return `Status cannot be changed from ${fromStatus} to ${toStatus}. Allowed next status: ${allowedStatusList}.`;
}
